<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ProjPoint',
})
</script>
<template>
  <BdTable :config="tableConfig" />
</template>

<script lang="ts" setup name="ProjPoint">
import { BdTable } from '-/Base/BdTable'
import useTable from './useTable'
const { tableConfig } = useTable()
</script>
